/**
 * Maps our data's country names to the names used by the world-atlas topojson
 * (Natural Earth `properties.name`), so choropleth values join correctly.
 * Most names already match exactly; only the well-known variants need fixing.
 * Anything not in the map is returned trimmed (the common case).
 */

const VARIANTS: Record<string, string> = {
  'united states': 'United States of America',
  'united states of america': 'United States of America',
  usa: 'United States of America',
  us: 'United States of America',
  'u.s.': 'United States of America',
  'u.s.a.': 'United States of America',
  uk: 'United Kingdom',
  'u.k.': 'United Kingdom',
  'great britain': 'United Kingdom',
  russia: 'Russia',
  'russian federation': 'Russia',
  'south korea': 'South Korea',
  'korea, republic of': 'South Korea',
  'republic of korea': 'South Korea',
  'north korea': 'North Korea',
  'czech republic': 'Czechia',
  uae: 'United Arab Emirates',
  'united arab emirates': 'United Arab Emirates',
  'bosnia and herzegovina': 'Bosnia and Herz.',
  'dominican republic': 'Dominican Rep.',
  'ivory coast': "Côte d'Ivoire",
};

export const toAtlasCountry = (name: string | null | undefined): string => {
  const trimmed = (name || '').trim();
  if (!trimmed) return '';
  return VARIANTS[trimmed.toLowerCase()] || trimmed;
};

/**
 * Build an atlas-name → numeric value map from a list of {country, value}
 * rows. Values for names that normalize to the same atlas country are summed.
 */
export const buildCountryValueMap = <T extends { country: string }>(
  rows: T[],
  valueOf: (_row: T) => number,
): Map<string, number> => {
  const out = new Map<string, number>();
  rows.forEach((r) => {
    const key = toAtlasCountry(r.country);
    if (!key) return;
    out.set(key, (out.get(key) || 0) + valueOf(r));
  });
  return out;
};
